module.exports = __webpack_public_path__ + "img/why-use-oc-image-02.ccaed30.svg";